// extracted by mini-css-extract-plugin
module.exports = {"link":"style_link__j7sUM"};